import { render, staticRenderFns } from "./new.faqs.page.vue?vue&type=template&id=05bf2f68&"
import script from "./new.faqs.page.vue?vue&type=script&lang=js&"
export * from "./new.faqs.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports